import { gql } from '@apollo/client';

export const GET_DISEASES_WITH_DATES = gql`
  query GetDiseasesWithDates($limit: Int, $nextToken: String) {
    listDiseases(limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        icd10_code
        short_description
        content
        created_at
        updated_at
        is_active
      }
      nextToken
    }
  }
`;

export const GET_DISEASES = gql`
  query GetDiseases($limit: Int, $nextToken: String) {
    listDiseases(limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        icd10_code
        short_description
        content
        is_active
        created_at
        updated_at
        thumbnail_url
      }
      nextToken
    }
  }
`;

export const GET_DISEASES_SAFE = gql`
  query GetDiseasesSafe($limit: Int, $nextToken: String) {
    listDiseases(limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        icd10_code
        short_description
        content
        is_active
      }
      nextToken
    }
  }
`;

export const GET_DISEASE = gql`
  query GetDisease($id: ID!) {
    getDisease(id: $id) {
      id
      name
      icd10_code
      short_description
      content
      created_at
      updated_at
      is_active
      images {
        id
        image_url
        thumbnail_url
        body_location
        severity
        fitzpatrick_skin_tone
        is_primary
      }
      treatments {
        id
        name
        description
        treatment_type
        instructions
        regular_price
        sale_price
        image_url
        is_active
        created_at
        updated_at
      }
    }
  }
`;

export const GET_DISEASE_SAFE = gql`
  query GetDiseaseSafe($id: ID!) {
    getDisease(id: $id) {
      id
      name
      icd10_code
      short_description
      content
      is_active
      images {
        id
        image_url
        thumbnail_url
        body_location
        severity
        fitzpatrick_skin_tone
        is_primary
      }
      treatments {
        id
        name
        description
        treatment_type
        instructions
        regular_price
        sale_price
        image_url
        is_active
      }
    }
  }
`;

export const CREATE_DISEASE = gql`
  mutation CreateDisease($input: DiseaseInput!) {
    createDisease(input: $input) {
      id
      name
      icd10_code
      short_description
      content
      created_at
      updated_at
      is_active
    }
  }
`;

export const UPDATE_DISEASE = gql`
  mutation UpdateDisease($id: ID!, $input: UpdateDiseaseInput!) {
    updateDisease(id: $id, input: $input)
  }
`;

export const DELETE_DISEASE = gql`
  mutation DeleteDisease($id: ID!) {
    deleteDisease(id: $id)
  }
`;

export const CREATE_DISEASE_IMAGE = gql`
  mutation CreateDiseaseImage($input: DiseaseImageInput!) {
    createDiseaseImage(input: $input) {
      id
      disease_id
      image_url
      thumbnail_url
      body_location
      severity
      fitzpatrick_skin_tone
      is_primary
    }
  }
`;

export const UPDATE_DISEASE_IMAGE = gql`
  mutation UpdateDiseaseImage($id: ID!, $input: DiseaseImageInput!) {
    updateDiseaseImage(id: $id, input: $input) {
      id
      disease_id
      image_url
      thumbnail_url
      body_location
      severity
      fitzpatrick_skin_tone
      is_primary
    }
  }
`;

export const DELETE_DISEASE_IMAGE = gql`
  mutation DeleteDiseaseImage($id: ID!) {
    deleteDiseaseImage(id: $id)
  }
`;

export const LIST_DISEASE_IMAGES = gql`
  query ListDiseaseImages($disease_id: ID, $limit: Int, $nextToken: String) {
    listDiseaseImages(disease_id: $disease_id, limit: $limit, nextToken: $nextToken) {
      items {
        id
        disease_id
        image_url
        thumbnail_url
        body_location
        severity
        fitzpatrick_skin_tone
        is_primary
      }
      nextToken
    }
  }
`;

export const GET_TREATMENTS = gql`
  query GetTreatments($filter: TreatmentFilterInput, $limit: Int, $nextToken: String) {
    listTreatments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        treatment_type
        instructions
        regular_price
        sale_price
        image_url
        is_active
        created_at
        updated_at
      }
      nextToken
    }
  }
`;

export const GET_TREATMENTS_SAFE = gql`
  query GetTreatmentsSafe($filter: TreatmentFilterInput, $limit: Int, $nextToken: String) {
    listTreatments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        treatment_type
        instructions
        regular_price
        sale_price
        image_url
        is_active
      }
      nextToken
    }
  }
`;

export const CREATE_TREATMENT = gql`
  mutation CreateTreatment($input: TreatmentInput!) {
    createTreatment(input: $input) {
      id
      name
      description
      treatment_type
      instructions
      regular_price
      sale_price
      image_url
      created_at
      updated_at
      is_active
    }
  }
`;

export const LINK_DISEASE_TREATMENT = gql`
  mutation LinkDiseaseTreatment(
    $diseaseId: ID!
    $treatmentId: ID!
    $effectiveness_rating: Float
    $recommendation_order: Int
  ) {
    linkDiseaseTreatment(
      diseaseId: $diseaseId
      treatmentId: $treatmentId
      effectiveness_rating: $effectiveness_rating
      recommendation_order: $recommendation_order
    )
  }
`;

export const SEARCH_DISEASES = gql`
  query SearchDiseasesFTS($query: String!, $limit: Int) {
    searchDiseases(query: $query, limit: $limit) {
      items {
        id
        name
        icd10_code
        short_description
        content
        is_active
        created_at
        updated_at
        thumbnail_url
      }
      nextToken
    }
  }
`;

export const SEARCH_TREATMENTS = gql`
  query SearchTreatmentsFTS($query: String!, $limit: Int) {
    searchTreatments(query: $query, limit: $limit) {
      items {
        id
        name
        description
        treatment_type
        instructions
        regular_price
        sale_price
        image_url
        is_active
        created_at
        updated_at
      }
      nextToken
    }
  }
`;

export const SEARCH_ALL = gql`
  query SearchAllFTS($query: String!, $limit: Int) {
    diseases: searchDiseases(query: $query, limit: $limit) {
      items {
        id
        name
        icd10_code
        short_description
        content
        is_active
        thumbnail_url
      }
    }
    treatments: searchTreatments(query: $query, limit: $limit) {
      items {
        id
        name
        description
        treatment_type
        instructions
        regular_price
        sale_price
        image_url
        is_active
        created_at
        updated_at
      }
    }
  }
`;

export const DELETE_TREATMENT = gql`
  mutation DeleteTreatment($id: ID!) {
    deleteTreatment(id: $id)
  }
`;

export const GET_TREATMENT = gql`
  query GetTreatment($id: ID!) {
    getTreatment(id: $id) {
      id
      name
      description
      treatment_type
      instructions
      regular_price
      sale_price
      image_url
      created_at
      updated_at
      is_active
    }
  }
`;

export const UPDATE_TREATMENT = gql`
  mutation UpdateTreatment($id: ID!, $input: UpdateTreatmentInput!) {
    updateTreatment(id: $id, input: $input)
  }
`;

export const LIST_TRAINING_SAMPLES = gql`
  query ListTrainingSamples($filter: TrainingSampleFilterInput, $limit: Int, $nextToken: String, $sortDirection: SortDirection) {
    listTrainingSamples(filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items {
        id
        original_image_url
        thumbnail_url
        symptoms_description
        prediction
        confidence
        differential_diagnoses
        model_version
        ai_summary
        review_status
        reviewed_by
        reviewed_at
        correct_diagnosis
        staff_notes
        is_validated
        validation_quality
        use_for_training
        training_category
        image_quality
        diagnosis_clarity
        label_id
        body_zone_ids
        llm_analysis
        created_at
        updated_at
      }
      nextToken
    }
  }
`;

export const GET_TRAINING_SAMPLE = gql`
  query GetTrainingSample($id: ID!) {
    getTrainingSample(id: $id) {
      id
      original_image_url
      thumbnail_url
      symptoms_description
      prediction
      confidence
      differential_diagnoses
      model_version
      ai_summary
      review_status
      reviewed_by
      reviewed_at
      correct_diagnosis
      staff_notes
      is_validated
      validation_quality
      use_for_training
      training_category
      image_quality
      diagnosis_clarity
      label_id
      body_zone_ids
      llm_analysis
      created_at
      updated_at
    }
  }
`;

export const GET_TRAINING_SAMPLE_WITH_DISEASE = gql`
  query GetTrainingSampleWithDisease($id: ID!) {
    getTrainingSample(id: $id) {
      id
      original_image_url
      thumbnail_url
      symptoms_description
      prediction
      confidence
      differential_diagnoses
      model_version
      ai_summary
      review_status
      reviewed_by
      reviewed_at
      correct_diagnosis
      staff_notes
      is_validated
      validation_quality
      use_for_training
      training_category
      image_quality
      diagnosis_clarity
      label_id
      disease {
        id
        name
        icd10_code
        short_description
      }
      body_zone_ids
      llm_analysis
      created_at
      updated_at
    }
  }
`;

export const UPDATE_TRAINING_SAMPLE = gql`
  mutation UpdateTrainingSample($id: ID!, $input: UpdateTrainingSampleInput!) {
    updateTrainingSample(id: $id, input: $input)
  }
`;

export const DELETE_TRAINING_SAMPLE = gql`
  mutation DeleteTrainingSample($id: ID!) {
    deleteTrainingSample(id: $id)
  }
`;

export const GET_TOP_DIAGNOSES = gql`
  query GetTopDiagnoses($timePeriodHours: Int, $limit: Int) {
    getTopDiagnoses(timePeriodHours: $timePeriodHours, limit: $limit) {
      items {
        disease_name
        count
        percentage
      }
      total_diagnoses
    }
  }
`;
